// extracted by mini-css-extract-plugin
export default {"titleBar":"TitleBar_titleBar__YV3Id"};